import React, { useState } from 'react';
import { Menu, X, Shield, Phone } from 'lucide-react';
import { Button } from '../ui/button';
import { siteConfig } from '../../data/mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Services', href: '#services' },
    { name: 'Why Us', href: '#why-us' },
    { name: 'Locations', href: '#locations' },
    { name: 'Careers', href: '#careers' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <header className="fixed top-0 w-full z-50 bg-black border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3 group">
            <Shield className="w-10 h-10 text-[#00FFD1] transition-transform duration-300 group-hover:scale-110" />
            <span className="text-white font-semibold text-xl tracking-tight">
              {siteConfig.companyName}
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-[#4D4D4D] hover:text-white text-lg font-normal transition-colors duration-300"
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href={`tel:${siteConfig.phone}`}
              className="flex items-center gap-2 text-white/85 hover:text-[#00FFD1] transition-colors duration-300"
            >
              <Phone className="w-5 h-5" />
              <span className="text-lg">{siteConfig.phone}</span>
            </a>
            <Button
              className="bg-[#00FFD1] text-black hover:bg-[#00FFD1]/10 hover:text-[#00FFD1] rounded-none px-6 py-3 text-lg font-medium transition-all duration-400"
            >
              Free Consultation
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 text-white"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="w-7 h-7" />
            ) : (
              <Menu className="w-7 h-7" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden border-t border-white/10 py-6">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-white/70 hover:text-white text-lg py-2 transition-colors duration-300"
                >
                  {link.name}
                </a>
              ))}
              <div className="pt-4 border-t border-white/10 mt-2">
                <a
                  href={`tel:${siteConfig.phone}`}
                  className="flex items-center gap-2 text-[#00FFD1] py-2"
                >
                  <Phone className="w-5 h-5" />
                  <span>{siteConfig.phone}</span>
                </a>
                <Button
                  className="w-full mt-4 bg-[#00FFD1] text-black hover:bg-[#00FFD1]/10 hover:text-[#00FFD1] rounded-none py-4 text-lg font-medium"
                >
                  Free Consultation
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
